const GET_TOKEN = "GET_TOKEN";

export { GET_TOKEN };
